import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

interface EacColumnHeaderProps {
  /** Method actually used, including any fallback */
  methodBadgeText: string;
}

export function EacColumnHeader({ methodBadgeText }: EacColumnHeaderProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="inline-flex items-center gap-1.5 cursor-help justify-end">
            <span className="underline decoration-dotted underline-offset-2">EAC</span>
            <span className="rounded-full border border-border bg-muted px-1.5 py-0.5 text-[10px] font-medium text-muted-foreground leading-none">
              {methodBadgeText}
            </span>
          </span>
        </TooltipTrigger>
        <TooltipContent side="top" className="text-xs">
          Estimate at Completion — {methodBadgeText} method
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
